import * as React from 'react'

import { ArrowDownAZ, ArrowUpZA } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import SortOrder from '~/client/src/shared/enums/SortOrder'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  value: SortOrder
  onChange: (next: SortOrder) => void
  disabled?: boolean
}

const OrderToggle: React.FC<IProps> = ({ value, onChange, disabled }) => {
  const isAsc = value === SortOrder.ASC
  const Icon = isAsc ? ArrowDownAZ : ArrowUpZA
  const label = isAsc
    ? Localization.translator.ascending
    : Localization.translator.descending

  return (
    <Button
      variant="outline"
      disabled={disabled}
      onClick={() => onChange(isAsc ? SortOrder.DESC : SortOrder.ASC)}
    >
      <Icon />
      {label}
    </Button>
  )
}

export default OrderToggle
